export default {
	title: 'Plano estratégico',
	tabs: {
		general: {
			title: 'Geral'
		},
		filters: {
			title: 'Filtros de vista'
		},
		bot: {
			title: 'IA'
		},
		export: {
			title: 'Exportar'
		},
		display: {
			title: 'Exibição'
		}
	},
	filters: {
		responsible: {
			title: 'Filtro por responsável',
			placeholder: 'Nome do responsável'
		},
		completion: {
			title: 'Filtro de conclusão',
			not_started: 'Não iniciado',
			in_progress: 'Em andamento',
			completed: 'Concluído'
		},
		dates: {
			title: 'Filtro de datas'
		},
		startOn: {
			title: 'Filtro de data de início',
			undefined: 'Sem data',
			past: 'Passado',
			ending_week: 'Começa em uma semana',
			ending_month: 'Começa em um mês',
			ending_quarter: 'Começa em um trimestre',
			ending_year: 'Começa em um ano'
		},
		endOn: {
			title: 'Filtro de data de término',
			undefined: 'Sem data',
			done: 'Concluído',
			overdue: 'Atrasado',
			ending_week: 'Termina em uma semana',
			ending_month: 'Termina em um mês',
			ending_quarter: 'Termina em um trimestre',
			ending_year: 'Termina em um ano'
		}
	},

	display: {
		sort: {
			title: 'Ordenação dos ramos',
			startOn: 'Por data de início',
			name: 'Por nome',
			manual: 'Ordem manual'
		}
	},
	all_icons: 'Filtro de ícones',
	no_icon: 'Sem ícone',
	onboarding: {
		title: 'Revisão do plano de ação',
		description:
			'Verifique se os eixos e itens correspondem à sua leitura do plano.'
	}
};
